/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export const PledgeFiatModal: React.FC = () => {
    return (
        <div
            className="modal fade"
            id="pledgeFiat"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="pledgeFiatLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <strong className="modal-title" id="pledgeFiatLabel"></strong>
                        <a data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa-solid fa-x"></i>
                        </a>
                    </div>
                    <div className="modal-body">
                        <div className="qr-img text-center pb-4">
                            <img
                                src="https://marketplace.nfty.property/img/qr4.png"
                                className="img-fluid"
                                alt=""
                            />
                        </div>

                        <div className="send-address text-center popup-4p">
                            <h2>
                                To secure your pledge now, deposit <br /> the funds to be held
                                in trust at the <br /> account below;
                            </h2>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="popup-5-item popup-border">
                                    <h6>Payments made from inside the EU:</h6>
                                    <ul>
                                        <li>
                                            <span>Account holder:</span> Squarely
                                        </li>
                                        <li>
                                            <span>BIC:</span> TRWIBEB1XXX
                                        </li>
                                        <li>
                                            <span>IBAN:</span> BE66 9672 1832 5643
                                        </li>
                                        <li>
                                            <span>Wise’s address: </span> Avenue Louise 54, Room S52,
                                            Brussels, 1050, Belgium
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="popup-5-item">
                                    <h6>Payments made from outside the EU:</h6>
                                    <ul>
                                        <li>
                                            <span>Account holder:</span> Squarely
                                        </li>
                                        <li>
                                            <span>Account number:</span> 26161762
                                        </li>
                                        <li>
                                            <span>Sort code:</span> 23-14-70
                                        </li>
                                        <li>
                                            <span>Wise’s address: </span> Avenue Louise 54, Room S52,
                                            Brussels, 1050, Belgium
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="popup-done">
                            <a data-bs-dismiss="modal" aria-label="Close">
                                Done
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};